import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

function eventNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "event", next, x, y });
}

// 参照図の分岐。初手の先は道ごとに種類を変える。ボス手前だけ入次数2。
export const MAP_NODES_STABILIZE: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["c1l", "c1m", "c1r"], x: 3, y: 0 }),
  c1l: caseNode("c1l", ["e2l"], 1, 1),
  c1m: caseNode("c1m", ["c2m"], 3, 1),
  c1r: caseNode("c1r", ["rest-2r"], 5, 1),
  e2l: eventNode("e2l", ["c3a", "rest-3b"], 1, 2),
  c2m: caseNode("c2m", ["rest-3b", "c3c"], 3, 2),
  "rest-2r": restNode("rest-2r", ["c3d", "e3e"], 5, 2),
  c3a: caseNode("c3a", ["c4a"], 0, 3),
  "rest-3b": restNode("rest-3b", ["rest-4b"], 2, 3),
  c3c: caseNode("c3c", ["e4c"], 3, 3),
  c3d: caseNode("c3d", ["c4d"], 4, 3),
  e3e: eventNode("e3e", ["c4e"], 6, 3),
  c4a: caseNode("c4a", ["rest-5a"], 0, 4),
  "rest-4b": restNode("rest-4b", ["c5b"], 2, 4),
  e4c: eventNode("e4c", ["rest-5c", "c5d"], 3, 4),
  c4d: caseNode("c4d", ["e5e"], 4, 4),
  c4e: caseNode("c4e", ["rest-5f"], 6, 4),
  "rest-5a": restNode("rest-5a", ["e6a"], 0, 5),
  c5b: caseNode("c5b", ["c6b"], 1, 5),
  "rest-5c": restNode("rest-5c", ["e6c"], 2, 5),
  c5d: caseNode("c5d", ["e6c"], 3, 5),
  e5e: eventNode("e5e", ["c6d"], 5, 5),
  "rest-5f": restNode("rest-5f", ["c6e"], 6, 5),
  e6a: eventNode("e6a", ["c7a"], 0, 6),
  c6b: caseNode("c6b", ["c7a"], 1, 6),
  e6c: eventNode("e6c", ["rest-7b"], 3, 6),
  c6d: caseNode("c6d", ["c7c"], 5, 6),
  c6e: caseNode("c6e", ["c7d"], 6, 6),
  c7a: caseNode("c7a", ["c8a"], 0, 7),
  "rest-7b": restNode("rest-7b", ["c8b"], 2, 7),
  c7c: caseNode("c7c", ["c8c"], 4, 7),
  c7d: caseNode("c7d", ["c8c"], 6, 7),
  c8a: caseNode("c8a", ["rest-pre-l"], 1, 8),
  c8b: caseNode("c8b", ["rest-pre-l"], 3, 8),
  c8c: caseNode("c8c", ["rest-pre-r"], 5, 8),
  "rest-pre-l": restNode("rest-pre-l", ["boss"], 2, 9),
  "rest-pre-r": restNode("rest-pre-r", ["boss"], 4, 9),
  boss: node("boss", { kind: "case", caseId: "stabilize-boss", next: [], x: 3, y: 10 }),
};
